import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Col, Container, Row } from "react-bootstrap";
import ReactSlider from "react-slider";
import chaletStore from "../state/chaletstore";

export const SettingsPage = () => {

  const rooms = chaletStore(state => state.data.rooms)
  const updateRoom = chaletStore(state => state.updateRoom)
  const changeHandler = ({ value, index, roomId }: { value: any, index: number, roomId: string }) => {
    console.log(`onAfterChange: ${JSON.stringify({ value, index, roomId })}`)
    if (index === 0) {
      updateRoom(roomId, "updateTargetOff", value[0])
    }
    else {
      updateRoom(roomId, "updateTargetOn", value[1])
    }
  }
  return (
    <div>
      <Container className="pt-5 pb-5 ">
        <Row className="justify-content-center pb-5">
          <Col className="col-lg-12 col-xs-auto">
            <h3> Target Temperature Settings</h3>
          </Col>
        </Row>
        <Row className="justify-content-center pb-5">
          <Col className="col-lg-3 col-xs-auto"><b>Room</b></Col>
          <Col className="col-lg-3 col-xs-auto"><b>Target Temperatures</b></Col>
        </Row>
        {Object.values(rooms).map((room) => (
          <Row key={room.id} className="justify-content-center pb-5">
            <Col className="col-lg-3 col-xs-auto">{room.name}</Col>
            <Col className="col-lg-3 col-xs-auto">
              <ReactSlider
                min={6}
                max={24}
                className="horizontal-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                value={[room.targetTempOff, room.targetTempOn]}
                renderThumb={(props, state) => {
                  const key = props.key
                  delete props.key
                  return <div key={key} {...props}>{state.valueNow}</div>
                }}
                ariaLabel={['Leftmost thumb', 'Middle thumb']}
                pearling
                minDistance={1}
                step={0.5}
                onAfterChange={(value, index) => changeHandler({ value, index, roomId: room.id })}
              />
            </Col>
          </Row>
        ))}
      </Container>
    </div>
  );
};
